import styled from 'styled-components';

export const CasesPageContainer = styled.div``;